import { MonthOption, TZ } from '../types/usage';

export const nowInPT = () =>
  new Date(new Date().toLocaleString('en-US', { timeZone: TZ }));

// PT month range converted to UTC ISO strings
// endISO is exclusive
export const monthRangePTAsUTCISO = (year: number, monthIdx: number) => {
  const startPT = new Date(year, monthIdx, 1, 0, 0, 0, 0).toLocaleString(
    'en-US',
    { timeZone: TZ }
  );
  const endPT = new Date(year, monthIdx + 1, 1, 0, 0, 0, 0).toLocaleString(
    'en-US',
    { timeZone: TZ }
  );

  const startUTC = new Date(startPT);
  const endUTC = new Date(endPT);

  return {
    startISO: startUTC.toISOString(),
    endISO: endUTC.toISOString()
  };
};

export const buildMonthOptions = (): MonthOption[] => {
  const startYear = 2025;
  const startMonthIdx = 3; // April 2025 (0-based)
  const end = nowInPT();
  const endYear = end.getFullYear();
  const endMonthIdx = end.getMonth();

  const options: MonthOption[] = [];
  const cursor = new Date(startYear, startMonthIdx, 1);

  while (
    cursor.getFullYear() < endYear ||
    (cursor.getFullYear() === endYear && cursor.getMonth() <= endMonthIdx)
  ) {
    const y = cursor.getFullYear();
    const mIdx = cursor.getMonth();
    const label = cursor.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric',
      timeZone: TZ
    });
    const key = `${y}-${String(mIdx + 1).padStart(2, '0')}`; // 'YYYY-MM'
    options.push({ key, label, year: y, monthIdx: mIdx });
    // advance 1 month
    cursor.setMonth(cursor.getMonth() + 1);
  }

  // Show newest first
  return options.reverse();
};
